import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SKU {
  id: string
  barcode: string
  styleNumber: string
  styleName: string
  styleShort?: string
  colorCode: string
  colorDescription?: string
  colorChinese?: string
  size: string
  source?: string
  createdAt: string
  createdBy: string
  creationMethod?: string
}

interface SKUState {
  skus: SKU[]
  loading: boolean
  total: number
  currentPage: number
  pageSize: number
}

const initialState: SKUState = {
  skus: [],
  loading: false,
  total: 0,
  currentPage: 1,
  pageSize: 20,
}

const skuSlice = createSlice({
  name: 'sku',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setSKUs: (state, action: PayloadAction<{ skus: SKU[]; total: number }>) => {
      state.skus = action.payload.skus
      state.total = action.payload.total
    },
    addSKU: (state, action: PayloadAction<SKU>) => {
      state.skus.unshift(action.payload)
      state.total += 1
    },
    updateSKU: (state, action: PayloadAction<SKU>) => {
      const index = state.skus.findIndex(sku => sku.id === action.payload.id)
      if (index !== -1) {
        state.skus[index] = action.payload
      }
    },
    deleteSKU: (state, action: PayloadAction<string>) => {
      state.skus = state.skus.filter(sku => sku.id !== action.payload)
      state.total -= 1
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
  },
})

export const { setLoading, setSKUs, addSKU, updateSKU, deleteSKU, setCurrentPage } = skuSlice.actions
export default skuSlice.reducer